import { OverviewContent } from '../../../billing/overview/OverviewContent';

// Own sessionStorage key so this embedded instance never fights the
// standalone billing section's saved range (see OverviewContent's doc
// comment on rangeStorageKey).
const RANGE_STORAGE_KEY = 'fv_accounts_practiceBillingOverviewRange';

interface PracticeBillingTabProps {
    practiceId: string;
}

// The exact billing Overview tab body (KPI strip, charts, rails), scoped to
// this practice and mounted inside the Accounts practice detail page.
export function PracticeBillingTab({ practiceId }: PracticeBillingTabProps) {
    return <OverviewContent practiceId={practiceId} rangeStorageKey={RANGE_STORAGE_KEY} />;
}
